export default {
    /**
     * Add a new vehicle
     *
     * @param {Object} state
     * @param {Object} data
     */
    addVehicle(state, data) {
        state.vehicles.push(data);
    },

    /**
     * Replace the vehicles data
     *
     * @param {Object} state
     * @param {Array} data
     */
    setVehicles(state, data) {
        state.vehicles = data;
    },

    /**
     * Update an existing vehicle
     *
     * @param {Object} state
     * @param {Object} data
     */
    updateVehicle(state, data) {
        const vehicle = state.vehicles.find(({ id }) => id === data.id);

        Object.assign(vehicle, data);
    },

    /**
     * Add or update a vehicle
     *
     * @param {Object} state
     * @param {Object} data
     */
    addOrUpdateVehicle(state, data) {
        const existingVehicle = state.vehicles.find(({ id }) => id === data.id);

        if (!existingVehicle) {
            return this.commit('user/addVehicle', data);
        }

        return this.commit('user/updateVehicle', data);
    },

    /**
     * Delete a vehicle
     *
     * @param {Object} state
     * @param {Object} data
     */
    deleteVehicle(state, vehicleId) {
        const vehicleIndex = state.vehicles.findIndex(({ id }) => id === vehicleId);

        state.vehicles.splice(vehicleIndex, 1);
    },
}
